exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.md-progress-bar[data-v-aa4b3aba] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n}\n.md-max-size[data-v-aa4b3aba] {\n  max-width: 400px;\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/views/authentication/login.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,QAAQ;CAAE;AAEZ;EACE,iBAAiB;CAAE","file":"login.vue","sourcesContent":[".md-progress-bar {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0; }\n\n.md-max-size {\n  max-width: 400px; }\n"],"sourceRoot":""}]);

// exports
